import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';
import { PageLoader } from '@/components/common/PageLoader';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { ProtectedRoute } from '@/components/guards/ProtectedRoute';
import { RecaptchaProvider } from '@/app/providers/RecaptchaProvider';

// Lazy load pages for better performance
const LoginPage = lazy(() => import('@/pages/auth/LoginPage'));
// const RegisterPage = lazy(() => import('@/pages/auth/RegisterPage'));
const MagicLinkVerifyPage = lazy(
  () => import('@/pages/auth/MagicLinkVerifyPage')
);
const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
const ProviderPage = lazy(() => import('@/pages/provider/ProviderPage'));
const CustomerLeadsPage = lazy(
  () => import('@/pages/customer-leads/CustomerLeadsPage')
);

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/provider" replace />,
  },
  {
    path: '/login',
    element: (
      <ErrorBoundary>
        <RecaptchaProvider>
          <Suspense fallback={<PageLoader />}>
            <LoginPage />
          </Suspense>
        </RecaptchaProvider>
      </ErrorBoundary>
    ),
  },
  // {
  //   path: '/register',
  //   element: (
  //     <ErrorBoundary>
  //       <Suspense fallback={<PageLoader />}>
  //         <RegisterPage />
  //       </Suspense>
  //     </ErrorBoundary>
  //   ),
  // },
  {
    path: '/magic/login',
    element: (
      <ErrorBoundary>
        <RecaptchaProvider>
          <Suspense fallback={<PageLoader />}>
            <MagicLinkVerifyPage />
          </Suspense>
        </RecaptchaProvider>
      </ErrorBoundary>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '/provider',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <ProtectedRoute>
            <ProviderPage />
          </ProtectedRoute>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '/customer-leads',
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <ProtectedRoute>
            <CustomerLeadsPage />
          </ProtectedRoute>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/provider" replace />,
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
